import React from 'react';
import { pageDefinition } from 'client/site-modules/shared/pages/page';
import { getCalculatorUrlParams } from 'site-modules/calculators/utils/get-calculator-url-params';
import { GAS_GUZZLER_BREADCRUMBS } from 'client/site-modules/calculators/constants/calculators';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { CalculatorsGasGuzzler } from './calculators-gas-guzzler';

export const pageDefinitionConfiguration = {
  name: 'calculators_gas_guzzler',
  category: 'calculators_gas_guzzler',
  component: props => <CalculatorsGasGuzzler {...getCalculatorUrlParams(props)} />,
  seo: {
    title: 'Gas Mileage Savings Calculator: Car Cost vs. Fuel Savings',
    keywords: 'Gas Mileage Savings Calculator, Fuel Efficient Car, Gas Guzzler',
    description:
      'This calculator shows how long will it take before you pay off the balance of a more fuel efficient car and really begin saving money on gas',
    jsonld: [getBreadcrumbSchema(GAS_GUZZLER_BREADCRUMBS)],
  },
};

export default pageDefinition(pageDefinitionConfiguration);
